import React, { useEffect, useState } from "react";
import Form, {
  SimpleItem, GroupItem, Label, RequiredRule, ButtonItem, ButtonOptions, TabbedItem, TabPanelOptions, Tab
} from 'devextreme-react/form';
import { Solicitar, Insertar, Modificar } from "../../Hooks/PeticiondeRegistros";
import { LVForm } from "../Basicos/LVForm";
import ComboAbmConCondicionesVenta from "../Compuestos/Combos/ComboAbmConCondicionesVenta";
import ComboAbmImpTiposIVA from "../Compuestos/Combos/ComboAbmImpTiposIVA";
import ComboVenDocsVentaTipos from "../Compuestos/Combos/ComboVenDocsVentaTipos";
import ComboVenListaPreciosCabecera from "../Compuestos/Combos/ComboVenListaPreciosCabecera";
import ComboAbmConCuentasContables from "../Compuestos/Combos/ComboAbmConCuentasContables";
import ComboAbmEexProfesionales from "../Compuestos/Combos/ComboAbmEexProfesionales";
import ComboAbmZonPlantas from "../Compuestos/Combos/ComboAbmZonPlantas";
import ComboAbmZonEmpresas from "../Compuestos/Combos/ComboAbmZonEmpresas";
import LVButtonAccion from "../Basicos/LVButtonAccion";
import LVNumberBox from "../Basicos/LVNumberBox";
import { LVGridCarga } from "../Basicos/LVGridCarga";
import { Column } from "devextreme-react/data-grid";
import { function_ABM_EEX_Clientes_Generar_JSON, function_ABM_EEX_Clientes_Insertar, function_ABM_EEX_Clientes_Leer, function_ABM_EEX_Clientes_Modificar } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Clientes";
import LV_EEX_ClientesLocaciones from "../Compuestos/Complejos/Clientes/LV_EEX_ClientesLocaciones";
import LV_EEX_ClientesPersonasRelevantes from "../Compuestos/Complejos/Clientes/LV_EEX_ClientesPersonasRelevantes";
import { function_VEN_ABM_EEX_ClientesPersonasRelevantes_Eliminar } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_ClientesPersonasRelevantes";
import { function_VEN_ABM_EEX_ClientesLocaciones_Eliminar } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_ClientesLocaciones";
import RadioGroup from "devextreme-react/radio-group";

const ABM_EEX_Clientes = (props) => {
  const [valorIdTipoIVA, setValorIdTipoIVA] = useState(null);
  const [valorIdTipoDocVentaDefault, setValorIdTipoDocVentaDefault] = useState(null);
  const [valorCodigoCondicionVenta, setValorCodigoCondicionVenta] = useState(null);
  const [valorCodigoListaPrecios, setValorCodigoListaPrecios] = useState(null);
  const [valorIdProfesionalVendedorAsignado, setValorIdProfesionalVendedorAsignado] = useState(null);
  const [valorCodigoCuentaContableDefault, setValorCodigoCuentaContableDefault] = useState(null);
  const [datos, setDatos] = useState([]);
  const [TituloBoton, setTituloBoton] = useState("");
  const [accionBoton, setAccionBoton] = useState("");
  const [esModificacion, setEsModificacion] = useState(false);
  const [esMultiEmpresa, setEsMultiEmpresa] = useState(true);
  const [esMultiPlanta, setEsMultiPlanta] = useState(true);
  const [bonificacionSeleccionadaOrden, setBonificacionSeleccionadaOrden] = useState(null);
  const [bonificacionSeleccionadaPorcentaje, setBonificacionSeleccionadaPorcentaje] = useState(null);
  const [bonificacionSeleccionadaSigno, setBonificacionSeleccionadaSigno] = useState("-");
  const [plantaSeleccionada, setPlantaSeleccionada] = useState(null);
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);

  const handleOnValueChangedMultiEmpresa = (e) => {
    const isChecked = e.value;

    setEsMultiEmpresa(isChecked)
    setDatos((prevDatos) => ({
      ...prevDatos,
      MultiEmpresa: isChecked
    }));
  };

  const handleOnValueChangedMultiPlanta = (e) => {
    const isChecked = e.value;

    setEsMultiPlanta(isChecked)
    setDatos((prevDatos) => ({
      ...prevDatos,
      MultiPlanta: isChecked
    }));
  };

  const handleOnClick_AgregarPlanta = async (e) => {
    if (!plantaSeleccionada.codigo) {
      alert("Seleccione una Planta antes de agregar.");
      return;
    }

    // Verificar si ya está en la lista
    const plantaYaExiste = datos.ListPlantas?.some(
      (planta) => planta.ABM_ZON_Plantas_CodigoPlanta === plantaSeleccionada.codigo
    );

    if (plantaYaExiste) {
      alert("La Planta ya ha sido agregada.");
      return;
    }

    // Crear el nuevo objeto
    const nuevaPlanta = {
      ABM_ZON_Plantas_CodigoPlanta: plantaSeleccionada.codigo,
      CodigoPlanta: plantaSeleccionada.codigo,
      Descripcion: plantaSeleccionada.descripcion,
      CodigoCompania: localStorage.getItem("CodigoCompania"),
      ABM_ART_Articulos_CodigoArticulo: ""
    };

    // Agregar el nuevo item a la coleccion
    setDatos((prevDatos) => ({
      ...prevDatos,
      ListPlantas: [...(prevDatos.ListPlantas || []), nuevaPlanta],
    }));

    // Limpiar la selección después de agregar
    setPlantaSeleccionada(null);
  }

  const handleOnClick_AgregarEmpresa = async (e) => {
    if (!empresaSeleccionada.codigo) {
      alert("Seleccione una Empresa antes de agregar.");
      return;
    }

    // Verificar si ya está en la lista
    const empresaYaExiste = datos.ListEmpresas?.some(
      (empresa) => empresa.ABM_ZON_Empresas_CodigoEmpresa === empresaSeleccionada.codigo
    );

    if (empresaYaExiste) {
      alert("La Empresa ya ha sido agregada.");
      return;
    }

    // Crear el nuevo objeto
    const nuevaEmpresa = {
      ABM_ZON_Empresas_CodigoEmpresa: empresaSeleccionada.codigo,
      CodigoEmpresa: empresaSeleccionada.codigo,
      Descripcion: empresaSeleccionada.descripcion,
      CodigoCompania: localStorage.getItem("CodigoCompania"),
      ABM_ART_Articulos_CodigoArticulo: ""
    };

    // Agregar el nuevo item a la coleccion
    setDatos((prevDatos) => ({
      ...prevDatos,
      ListEmpresas: [...(prevDatos.ListEmpresas || []), nuevaEmpresa],
    }));

    // Limpiar la selección después de agregar
    setEmpresaSeleccionada(null);
  }

  const handleOnClick_AgregarBonificacion = async (e) => {
    if (!bonificacionSeleccionadaOrden) {
      alert("Seleccione un Número de Orden.");
      return;
    }

    if (!bonificacionSeleccionadaPorcentaje) {
      alert("Seleccione un Porcentaje.");
      return;
    }

    // Verificar si la presentación ya está en la lista
    const bonificacionYaExiste = datos.RecargosBonificaciones?.some(
      (bonificacion) => bonificacion.Orden === bonificacionSeleccionadaOrden
    );

    if (bonificacionYaExiste) {
      alert("La bonificación ya ha sido agregada.");
      return;
    }

    // Crear el nuevo objeto de presentación
    const nuevaBonificacion = {
      Orden: bonificacionSeleccionadaOrden,
      Porcentaje: bonificacionSeleccionadaPorcentaje,
      CodigoCompania: localStorage.getItem("CodigoCompania"),
      IdCliente: props.Codigo.Codigo,
      Signo: bonificacionSeleccionadaSigno,
    };

    // Agregar la nueva presentación al estado
    setDatos((prevDatos) => ({
      ...prevDatos,
      RecargosBonificaciones: [...(prevDatos.RecargosBonificaciones || []), nuevaBonificacion],
    }));

    // Limpiar la selección después de agregar
    setBonificacionSeleccionadaOrden(null);
    setBonificacionSeleccionadaPorcentaje(null);
    setBonificacionSeleccionadaSigno("-");
  }

  const handleOnClick_Guardar = async (e) => {
    try {
      if (!datos.RazonSocial || datos.RazonSocial.trim() === "") {
        datos.RazonSocial = `${datos.Nombre || ""} ${datos.Apellido || ""}`.trim();
      }

      if (!datos.RazonSocial || datos.RazonSocial == "") {
        alert("Debe indicar la Razón Social o Nombre y Apellido.");
        return;
      }

      if (!valorIdTipoIVA || valorIdTipoIVA < 1) {
        alert("Debe indicar el Tipo de I.V.A..");
        return;
      }

      const JSON = await function_ABM_EEX_Clientes_Generar_JSON(
        datos.IdCliente,
        datos.MultiPlanta,
        datos.MultiEmpresa,
        datos.RazonSocial,
        datos.Apellido,
        datos.Nombre,
        datos.CUIT,
        valorIdTipoIVA,
        valorCodigoCuentaContableDefault,
        datos.Observaciones,
        valorIdTipoDocVentaDefault,
        valorIdProfesionalVendedorAsignado,
        valorCodigoCondicionVenta,
        valorCodigoListaPrecios,
        datos.Categoria,
        datos.HuellaDactilar,
        datos.HuellaDactilarString,
        datos.LimiteCreditoAviso,
        datos.LimiteCreditoCorte,
        datos.NombreFantasia,
        datos.PuntosAcumulados,
        datos.OpAutGenera,
        datos.OpAutIdProveedor,
        datos.OpAutIdTipoDocCompra,
        datos.OpAutCodigoSubCC,
        datos.OpAutCodigoCuentaFinanciera,
        datos.OpAutCodigoPlantaCompra,
        datos.SubidoEnNube,
        datos.Agrupador,
        datos.ListPlantas,
        datos.ListEmpresas,
        datos.Locaciones,
        datos.RecargosBonificaciones
      )

      console.log(JSON)
      if (props.Codigo.Codigo === "--NUEVO--") {

        const Creado = await function_ABM_EEX_Clientes_Insertar(JSON, false)

        alert("Se ha generado el Código: " + Creado.data.codigoGenerado)
      } else {

        const Modificado = await function_ABM_EEX_Clientes_Modificar(JSON, false)

        alert("Se ha modificado el Código: " + datos.IdCliente)
      }

      window.location.reload()
    } catch (error) {
      alert(error)
    }
  }

  useEffect(() => {
    const getData = async () => {
      try {
        if (props.Codigo.Codigo === "--NUEVO--") {
          setTituloBoton("GUARDAR")
          setAccionBoton("GUARDAR")

          setDatos({
            IdCliente: 0,
            MultiPlanta: true,
            MultiEmpresa: true,
            RazonSocial: '',
            Apellido: '',
            Nombre: '',
            CUIT: '',
            IdTipoIVA: 0,
            CodigoCuentaContableDefault: '',
            Observaciones: '',
            IdTipoDocVentaDefault: 0,
            IdProfesionalVendedorAsignado: 0,
            CodigoCondicionVenta: '',
            CodigoListaPrecios: '',
            Categoria: '',
            HuellaDactilar: '',
            HuellaDactilarString: '',
            LimiteCreditoAviso: 0,
            LimiteCreditoCorte: 0,
            NombreFantasia: '',
            PuntosAcumulados: 0,
            OpAutGenera: false,
            OpAutIdProveedor: 0,
            OpAutIdTipoDocCompra: 0,
            OpAutCodigoSubCC: '',
            OpAutCodigoCuentaFinanciera: '',
            OpAutCodigoPlantaCompra: '',
            SubidoEnNube: false,
            Agrupador: ''
          })
        } else {
          setTituloBoton("ACTUALIZAR CÓDIGO " + props.Codigo.Codigo)
          setAccionBoton("ACTUALIZAR CÓDIGO " + props.Codigo.Codigo)
          setEsModificacion(true)

          const datosDocumento = await function_ABM_EEX_Clientes_Leer(props.Codigo.Codigo)

          setDatos(datosDocumento.data)
        }
      } catch (error) {
        alert(error);
      }
    }
    getData();
  }, []);

  useEffect(() => {
    setEsMultiPlanta(datos.MultiPlanta)
    setEsMultiEmpresa(datos.MultiEmpresa)

    setValorCodigoCondicionVenta(datos.CodigoCondicionVenta)
    setValorCodigoCuentaContableDefault(datos.CodigoCuentaContableDefault)
    setValorCodigoListaPrecios(datos.CodigoListaPrecios)
    setValorIdProfesionalVendedorAsignado(datos.IdProfesionalVendedorAsignado)
    setValorIdTipoDocVentaDefault(datos.IdTipoDocVentaDefault)
    setValorIdTipoIVA(datos.IdTipoIVA)
  }, [datos]);

  const validateForm = (e) => {
    e.component.validate();
  };

  const onValueChangedIdTipoIVA = (e) => {
    setValorIdTipoIVA(e.value);
    datos.IdTipoIVA = e.value;
  }

  const onValueChangedIdTipoDocVentaDefault = (e) => {
    setValorIdTipoDocVentaDefault(e.value);
    datos.IdTipoDocVentaDefault = e.value;
  }

  const onValueChangedCodigoCondicionVenta = (e) => {
    setValorCodigoCondicionVenta(e.value);
    datos.CodigoCondicionVenta = e.value;
  }

  const onValueChangedCodigoListaPrecios = (e) => {
    setValorCodigoListaPrecios(e.value);
    datos.CodigoListaPrecios = e.value;
  }

  const onValueChangedIdProfesionalVendedorAsignado = (e) => {
    setValorIdProfesionalVendedorAsignado(e.value);
    datos.IdProfesionalVendedorAsignado = e.value;
  }

  const onValueChangedCodigoCuentaContableDefault = (e) => {
    setValorCodigoCuentaContableDefault(e.value);
    datos.CodigoCuentaContableDefault = e.value;
  }

  return (
    <LVForm
      colCount={1}
      formData={datos}
      onContentReady={validateForm}
    >
      <TabbedItem>
        <TabPanelOptions deferRendering={false} />

        <Tab title="General" colCount={2}>
          <GroupItem caption="General">
            <SimpleItem dataField="IdCliente" disabled={true} >
              <Label text="Código" />
            </SimpleItem>
            <SimpleItem dataField="RazonSocial">
              <Label text="Razón Social" />
            </SimpleItem>
            <SimpleItem dataField="Nombre">
              <Label text="Nombre" />
            </SimpleItem>
            <SimpleItem dataField="Apellido">
              <Label text="Apellido" />
            </SimpleItem>
            <SimpleItem dataField="NombreFantasia">
              <Label text="Nombre de Fantasía" />
            </SimpleItem>
            <SimpleItem dataField="CUIT">
              <Label text="C.U.I.T." />
            </SimpleItem>
          </GroupItem>

          <GroupItem caption="Detalles" colCount={2}>
            <SimpleItem dataField="Observaciones" editorType="dxTextArea">
              <Label text="Observaciones" />
            </SimpleItem>
            <SimpleItem dataField="Agrupador">
              <Label text="Agrupador" />
            </SimpleItem>
            <SimpleItem dataField="Categoria">
              <Label text="Categoría" />
            </SimpleItem>
            <SimpleItem dataField="PuntosAcumulados">
              <Label text="Puntos Acumulados" />
            </SimpleItem>

            <SimpleItem>
              <ComboAbmImpTiposIVA
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                value={valorIdTipoIVA}
                onValueChanged={onValueChangedIdTipoIVA} />
            </SimpleItem>
            <SimpleItem>
              <ComboAbmConCuentasContables
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                value={valorCodigoCuentaContableDefault}
                onValueChanged={onValueChangedCodigoCuentaContableDefault} />
            </SimpleItem>
            <SimpleItem>
              <ComboVenDocsVentaTipos
                value={valorIdTipoDocVentaDefault}
                onValueChanged={onValueChangedIdTipoDocVentaDefault} />
            </SimpleItem>
            <SimpleItem>
              <ComboAbmEexProfesionales
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                value={valorIdProfesionalVendedorAsignado}
                onValueChanged={onValueChangedIdProfesionalVendedorAsignado} />
            </SimpleItem>
            <SimpleItem>
              <ComboAbmConCondicionesVenta
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                value={valorCodigoCondicionVenta}
                onValueChanged={onValueChangedCodigoCondicionVenta} />
            </SimpleItem>
            <SimpleItem>
              <ComboVenListaPreciosCabecera
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                value={valorCodigoListaPrecios}
                onValueChanged={onValueChangedCodigoListaPrecios} />
            </SimpleItem>

            <GroupItem caption="Límites de Crédito">
              <SimpleItem dataField="LimiteCreditoAviso">
                <Label text="Aviso" />
              </SimpleItem>
              <SimpleItem dataField="LimiteCreditoCorte">
                <Label text="Corte" />
              </SimpleItem>
            </GroupItem>

          </GroupItem>
        </Tab>

        <Tab title="Locaciones" visible={esModificacion}>
          <GroupItem>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {datos.Locaciones?.map((loc, index) => (
                <div className="LV-GroupBox-div" key={index} style={{ position: "relative", padding: "10px" }}>
                  <LV_EEX_ClientesLocaciones
                    index={index}
                    datos={datos}
                    setDatos={setDatos}
                  />
                  <button
                    onClick={async () => {
                      const nuevasLocaciones = [...datos.Locaciones];
                      const locAEliminar = nuevasLocaciones[index];

                      if (locAEliminar?.IdCliente && locAEliminar?.CodigoLocacionCliente) {
                        const confirmacion = window.confirm("¿Seguro que querés eliminar esta locación?");
                        if (!confirmacion) return;

                        try {
                          await function_VEN_ABM_EEX_ClientesLocaciones_Eliminar(locAEliminar.IdCliente, locAEliminar.CodigoLocacionCliente);
                          alert("Locación eliminada con éxito del servidor.");
                        } catch (error) {
                          alert("Error al eliminar la locación: " + error.message);
                          return;
                        }
                      }

                      nuevasLocaciones.splice(index, 1);
                      setDatos((prev) => ({
                        ...prev,
                        Locaciones: nuevasLocaciones
                      }));
                    }}
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "5px",
                      background: "transparent",
                      border: "none",
                      color: "#900",
                      fontWeight: "bold",
                      fontSize: "18px",
                      cursor: "pointer"
                    }}
                  >
                    ✕
                  </button>
                </div>
              ))}
              <LVButtonAccion
                Texto="AGREGAR LOCACIÓN"
                onClick={() => {
                  const nuevaLocacion = {
                    CodigoLocacionCliente: "",
                    IdTipoLocacion: "",
                    Calle: "",
                    Numero: "",
                    Piso: "",
                    Depto: "",
                    CodigoPostal: "",
                    IdPais: "",
                    Email: "",
                    Telefono: "",
                    TelefonoFax: "",
                    TelefonoCelular: "",
                    HorarioAtencion: "",
                    Responsable1: "",
                    Responsable2: "",
                    Responsable3: "",
                    Observaciones: "",
                    EsDefaultParaRemito: false,
                    IdCiudad: "",
                    DomicilioFacturacion: false,
                    CodigoEmpresaTransporte: "",
                    CodigoLocacionEmpresaTransporte: "",
                    CodigoZona: "",
                    Coordenadas: ""
                  };
                  setDatos((prev) => ({
                    ...prev,
                    Locaciones: [...(prev.Locaciones || []), nuevaLocacion]
                  }));
                }}
              />
            </div>
          </GroupItem>
        </Tab>

        <Tab title="Personas Relevantes" visible={esModificacion}>
          <GroupItem>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {datos.PersonasRelevantes?.map((persona, index) => (
                <div className="LV-GroupBox-div" key={index} style={{ position: "relative", padding: "10px" }}>
                  <LV_EEX_ClientesPersonasRelevantes
                    index={index}
                    datos={datos}
                    setDatos={setDatos}
                  />
                  <button
                    onClick={async () => {
                      const nuevasPersonas = [...datos.PersonasRelevantes];

                      const personaAEliminar = nuevasPersonas[index];

                      if (personaAEliminar?.IdCliente) {
                        const confirmacion = window.confirm("¿Seguro que querés eliminar esta persona?");
                        if (!confirmacion) return;

                        try {
                          await function_VEN_ABM_EEX_ClientesPersonasRelevantes_Eliminar(personaAEliminar.IdCliente, personaAEliminar.Nombre, personaAEliminar.Apellido);
                          alert("Persona eliminada con éxito del servidor.");
                        } catch (error) {
                          alert("Error al eliminar la persona: " + error.message);
                          return;
                        }
                      }

                      nuevasPersonas.splice(index, 1);
                      setDatos((prev) => ({
                        ...prev,
                        PersonasRelevantes: nuevasPersonas
                      }));
                    }}
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "5px",
                      background: "transparent",
                      border: "none",
                      color: "#900",
                      fontWeight: "bold",
                      fontSize: "18px",
                      cursor: "pointer"
                    }}
                  >
                    ✕
                  </button>
                </div>
              ))
              }
              <LVButtonAccion
                Texto="AGREGAR PERSONA RELEVANTE"
                onClick={() => {
                  const nuevaPersona = {
                    Nombre: "",
                    Apellido: "",
                    Cargo: "",
                    Telefono: "",
                    Email: ""
                  };
                  setDatos((prev) => ({
                    ...prev,
                    PersonasRelevantes: [...(prev.PersonasRelevantes || []), nuevaPersona]
                  }));
                }}
              />
            </div>
          </GroupItem>
        </Tab>

        <Tab title="Bonificaciones/Recargos" visible={esModificacion}>
          <GroupItem colCount={2}>
            <div className="LV-GroupBox-div" style={{ marginBottom: '20px', width: '720px' }}>
              <div className="LV-GroupBox-div LV-FlexContainer" style={{ marginBottom: '20px', width: '700px' }}>
                <LVNumberBox TextoLabel="Orden" width={100} Texto={"Orden"} value={bonificacionSeleccionadaOrden} onValueChange={(e) => setBonificacionSeleccionadaOrden(e)} />
                <LVNumberBox TextoLabel="Porcentaje" width={100} Texto={"Porcentaje"} value={bonificacionSeleccionadaPorcentaje} onValueChange={(e) => setBonificacionSeleccionadaPorcentaje(e)} />

                <RadioGroup
                  items={[
                    { text: "Bonificación", value: "-" },
                    { text: "Recargo", value: "+" }
                  ]}
                  value={bonificacionSeleccionadaSigno}
                  layout="horizontal"
                  valueExpr="value"
                  displayExpr="text"
                  onValueChanged={(e) => setBonificacionSeleccionadaSigno(e.value)}
                  style={{ margin: '0 10px' }}
                />

                <LVButtonAccion Texto={"AGREGAR"} onClick={handleOnClick_AgregarBonificacion} />
              </div>
              <LVGridCarga
                id="gridContainerBonificaciones"
                dataSource={datos.RecargosBonificaciones}
                keyExpr="Orden"
                width={400}
              >
                <Column caption="Orden" dataField="Orden" width="80" alignment="Left" dataType="string" />
                <Column caption="Porcentaje" dataField="Porcentaje" width="100" alignment="Left" dataType="string" />
                <Column caption="Signo" dataField="Signo" width="40" alignment="Left" dataType="string" />
              </LVGridCarga>
            </div>
          </GroupItem>
        </Tab>

        <Tab title="Plantas">
          <GroupItem>
            <SimpleItem dataField="MultiPlanta" editorType="dxCheckBox"
              editorOptions={{ onValueChanged: (e) => handleOnValueChangedMultiPlanta(e) }}>
              <Label text="MultiPlanta (Desactivado permite definir para que Plantas estará disponible)" />
            </SimpleItem>
          </GroupItem>

          <GroupItem visible={!esMultiPlanta}>
            <div className="LV-FlexContainer" style={{ marginBottom: '20px' }}>
              <ComboAbmZonPlantas
                ancho="500"
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                onValueChanged={(e) => {
                  const descripcion = e.component && typeof e.component.option === "function"
                    ? e.component.option("text")
                    : "";
                  setPlantaSeleccionada({ codigo: e.value, descripcion });
                }} />
              <LVButtonAccion Texto={"AGREGAR PLANTA"} onClick={handleOnClick_AgregarPlanta} />
            </div>

            <LVGridCarga
              id="gridContainer"
              dataSource={datos.ListPlantas}
              keyExpr="ABM_ZON_Plantas_CodigoPlanta"
            >
              <Column caption="Código" dataField="ABM_ZON_Plantas_CodigoPlanta" width="80" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="Descripcion" width="100%" minWidth="200" alignment="Left" dataType="string" />
            </LVGridCarga>
          </GroupItem>
        </Tab>

        <Tab title="Empresas">
          <GroupItem>
            <SimpleItem dataField="MultiEmpresa" editorType="dxCheckBox"
              editorOptions={{ onValueChanged: (e) => handleOnValueChangedMultiEmpresa(e) }}>
              <Label text="MultiEmpresa (Desactivado permite definir para que Empresas estará disponible)" />
            </SimpleItem>
          </GroupItem>

          <GroupItem visible={!esMultiEmpresa}>
            <div className="LV-FlexContainer" style={{ marginBottom: '20px' }}>
              <ComboAbmZonEmpresas
                ancho="500"
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                onValueChanged={(e) => {
                  const descripcion = e.component && typeof e.component.option === "function"
                    ? e.component.option("text")
                    : "";
                  setEmpresaSeleccionada({ codigo: e.value, descripcion });
                }} />
              <LVButtonAccion Texto={"AGREGAR EMPRESA"} onClick={handleOnClick_AgregarEmpresa} />
            </div>

            <LVGridCarga
              id="gridContainer"
              dataSource={datos.ListEmpresas}
              keyExpr="ABM_ZON_Empresas_CodigoEmpresa"
            >
              <Column caption="Código" dataField="ABM_ZON_Empresas_CodigoEmpresa" width="80" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="Descripcion" width="100%" minWidth="200" alignment="Left" dataType="string" />
            </LVGridCarga>
          </GroupItem>
        </Tab>


      </TabbedItem>

      <ButtonItem horizontalAlignment="Center">
        <ButtonOptions onClick={handleOnClick_Guardar} type='success' useSubmitBehavior={true} text={TituloBoton} />
      </ButtonItem>
    </LVForm>
  );

}

export default ABM_EEX_Clientes;